<template>
  <div class="step-section-3" style="padding-top: 20px">
    <el-col :span="24" class="step2-zy-container">
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
      >

        <el-col :span="10" :offset="1">
          <div style="width: 1px; height: 20px"></div>
           <el-form-item label="复用既往填报信息" label-width="160px">
            <el-button icon="el-icon-search" circle @click="getDwxx()"></el-button>
          </el-form-item>
          <el-form-item label="单位名称" prop="dwmc" label-width="120px">
            <el-input v-model="ruleForm.dwmc"></el-input>
          </el-form-item>
          <el-form-item label="组织机构代码" prop="zzjgdm" label-width="120px">
            <el-input v-model="ruleForm.zzjgdm"></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="lxr" label-width="120px">
            <el-input v-model="ruleForm.lxr"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="lxdh" label-width="120px">
            <el-input v-model="ruleForm.lxdh"></el-input>
          </el-form-item>
          <el-form-item label="学生可见电话" prop="lxdh_to_student" label-width="120px">
            <el-input v-model="ruleForm.lxdh_to_student"></el-input>
          </el-form-item>
          <el-form-item label="联系邮箱" prop="lxyx" label-width="120px">
            <el-input v-model="ruleForm.lxyx"></el-input>
          </el-form-item>
          <el-form-item label="单位地址" prop="dwdzsqx" label-width="120px">
            <el-cascader
              :options="options"
              v-model="ruleForm.dwdzsqx"
              expand-trigger="hover"
              style="width: 100%"
            >
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="12" :offset="1">
          <el-form-item label="营业执照图" label-width="120px">
             <el-image
                style="width: 100px; height: 100px"
                :src="yyzz"
                :fit="fit" v-if="yyzz !='' && showOyyzz"
                :preview-src-list="[yyzz]"
              >
            </el-image>
            <el-upload
              action="#"
              :before-upload="checkYyzz"
              :http-request="uploadHandleYyzz"
              list-type="picture-card"  
              :limit="1"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="单位招聘简章" label-width="120px">
            <el-upload
              class="upload-demo"
              drag
              action="#"
              :http-request="uploadHandleZpjz"
              :limit="1"
              :before-upload="checkZpjz"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将PDF文件拖到此处，或
                <em>点击上传</em>
              </div>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-form>
    </el-col>
    <!--    查看上传的营业执照图-->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
// 引入外部js文件
import areaJs from '../../tools/select_area';
  import {isvalidPhone,isvalidEmail} from '../../tools/validate'
  import { get_uni_file_name } from '../../tools/tools';
    import COS from 'cos-js-sdk-v5'
  import axios from 'axios'
     var Bucket = 'ltxzcos-1256658379';
    var Region = 'ap-chengdu';     /* 存储桶所在地域，必须字段 */
              var cos = new COS({
                  // 必选参数
                  getAuthorization: function (options, callback) {
                      axios.get('https://ggff.1kawk.com/ltxz_cosAuth/getAuthToken.php').then ((response) => {
                        var data = response.data
                          var credentials = data && data.credentials;
                          if (!data || !credentials) return console.error('credentials invalid');
                          callback({
                              TmpSecretId: credentials.tmpSecretId,
                              TmpSecretKey: credentials.tmpSecretKey,
                              XCosSecurityToken: credentials.sessionToken,
                              // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
                              StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
                              ExpiredTime: data.expiredTime, // 时间戳，单位秒，如：1580000900
                          });
                      });
                  }
      });
   //定义一个全局的变量，谁用谁知道
  var validPhone=(rule, value,callback)=>{
      if (!value){
          callback(new Error('请输入电话号码'))
      }else  if (!isvalidPhone(value)){
        callback(new Error('请输入正确的11位手机号码'))
      }else {
          callback()
      }
  }
    var validEmail=(rule, value,callback)=>{
      if (!value){
          callback(new Error('请输入邮箱'))
      }else  if (!isvalidEmail(value)){
        callback(new Error('请输入正确的邮箱地址'))
      }else {
          callback()
      }
  }
  export default {
    name: 'StepSection3',
    data() {
      return {
        // 招聘会类型  1为医学类 2为非医学类
        type:0,
        options: areajson, //调用外部js文件的json数据
        //自定义 默认值
        yyzz: '',
        showOyyzz:true,
        zpjz: '',
        dwxx_id: '',
        //    七牛云上传--
        up_data: { token: '', key: '' },
        up_data_zpjz: { token: '', key: '' },
        ruleForm: {
          dwmc: '',
          zzjgdm: '',
          lxr: '',
          lxdh: '',
          lxdh_to_student:'',
          lxyx: '',
          dwdzsqx:[]
        },
        rules: {
          dwmc: [
            { required: true, message: '请输入单位名称', trigger: 'blur' },
          ],
          zzjgdm: [
            { required: true, message: '请输入组织机构代码', trigger: 'blur' },
          ],
          lxr: [
            { required: true, message: '请输入联系人姓名', trigger: 'blur' },
          ],
          lxdh: [
             { required: true, trigger: 'blur', validator: validPhone }//这里需要用到全局变量
          ],
          lxdh_to_student: [
            { required: true, message: '请输入学生可见的联系电话', trigger: 'blur' },
          ],
          lxyx: [
            { required: true, trigger: 'blur', validator: validEmail }//这里需要用到全局变量
          ],
          dwdzsqx: [
            { required: true, message: '请选择单位地址市区县', trigger: 'change' }
          ],
        },
        dialogImageUrl: '',
        dialogVisible: false,
        checkFormStatus: '0',
      }
    },
    created() {
     
    },
    methods: {
      getDwxx(){
         let that = this;
         this.$prompt('请输入组织机构代码', '复用既往填报内容', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          // 发起post请求，获取单位信息
           axios
              .post(
                'https://cfp.1kawk.com/lantu_s_php/get_dwxx.php',
                {
                  zzjgdm: value,
                }
              )
              .then(function (res) {
               if(res.data.status == 'success'){
                    
                    that.yyzz=res.data.yyzz,
                    that.ruleForm= {
                    dwmc: res.data.dwmc,
                    zzjgdm: value,
                    lxr: res.data.lxr,
                    lxdh: res.data.lxdh,
                    lxdh_to_student:res.data.lxdh_to_student,
                    lxyx: res.data.lxyx,
                    dwdzsqx:res.data.dwdzsqx.split(","),
                  },  
                that.$message({
                  type: 'success',
                  message: '获取成功，已自动填充部分信息'
                });
               }else{
                  that.$message.error(res.data.msg);
               }
              })

          // this.$message({
          //   type: 'success',
          //   message: '填写的内容是 ' + value
          // });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });
      },
      checkForm() {
        let that = this
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            // 表单数据验证通过
            if (that.yyzz == '') {
              this.$message({
                type: 'error',
                message: '营业执照必须上传！',
              })
              this.checkFormStatus = '1'
              return false
            } else if (that.zpjz == '') {
              this.$message({
                type: 'error',
                message: '招聘简章文件必须上传！',
              })
              this.checkFormStatus = '2'
              return false
            }
            // 验证全部通过，提交单位数据到后台
            // 发起post请求
            
          axios.post(
                'https://cfp.1kawk.com/lantu_s_php/submit_company_data.php',
                {
                  dwmc: this.ruleForm.dwmc,
                  zzjgdm: this.ruleForm.zzjgdm,
                  lxr: this.ruleForm.lxr,
                  lxdh: this.ruleForm.lxdh,
                  lxdh_to_student: this.ruleForm.lxdh_to_student,
                  lxyx: this.ruleForm.lxyx,
                  dwdzsqx:this.ruleForm.dwdzsqx.toString(),
                  yyzz: this.yyzz,
                  zpjz: this.zpjz,
                  zph_id:23
                }
              )
              .then(function (res) {
                if(res.data.status == 'success'){
                  that.dwxx_id = res.data.id
                   that.checkFormStatus = 'success'
                   return true
                }else{
                  that.$message.error(res.data.msg);
                  that.checkFormStatus = '3'
                  return false
                }
               
              })
            //  that.checkFormStatus = 'success'
            //  return true
          }
        })
       
      },
      uploadHandleYyzz(data) {
        var fileData = data.file
        var that = this;
        if (!that.checkYyzz(fileData)){
          return false;
        }
        // 验证通过，进行文件的上传
          var key ='djzph_2024/yyzz/'+ get_uni_file_name(fileData.name);
          cos.putObject({
          Bucket: Bucket, /* 必须 */
          Region: Region,     /* 存储桶所在地域，必须字段 */
          Key: key,              /* 必须 */
          Body: fileData, // 上传文件对象
        }, function(err, data) {
          if(data.statusCode == 200){
            that.yyzz = 'https://'+data.Location;
            that.showOyyzz = false;
                that.$message({
              message: '营业执照上传成功',
              type: 'success'
            });
              }else{
                that.showOyyzz = false;
                that.yyzz = '';
                console.log(err);
                 that.$message({
              message: '营业执照上传失败，请重试'+err,
              type: 'success'
            });
              }
        }); 
       
      },
     
      uploadHandleZpjz(data){
         var fileData = data.file
        var that = this;
        if (!that.checkZpjz(fileData)){
          return false;
        }
        // 验证通过，进行文件的上传
          var key ='djzph_2024/zpjz/'+ get_uni_file_name(fileData.name);
          cos.putObject({
          Bucket: Bucket, /* 必须 */
          Region: Region,     /* 存储桶所在地域，必须字段 */
          Key: key,              /* 必须 */
          Body: fileData, // 上传文件对象
        }, function(err, data) {
          if(data.statusCode == 200){
            that.zpjz = 'https://'+data.Location;
                that.$message({
              message: '招聘简章上传成功',
              type: 'success'
            });
              }else{
                console.log(err);
                 that.$message({
              message: '招聘简章上传失败，请重试'+err,
              type: 'success'
            });
              }
        }); 
      },
      checkYyzz(fileData,fileList){
        const isJPG = fileData.type === 'image/jpeg' || fileData.type === 'image/png'
        const isLt10M = fileData.size / 1024 / 1024 < 10
        if (!isJPG) {
          this.$message({
            type: 'error',
            message: '上传营业执照图片只能是 JPG/PNG 格式！',
          })
          this.fileList = [];
          return false
        }
        if (!isLt10M) {
          this.$message({
            type: 'error',
            message: '营业执照图片大小不能超过 10MB!',
          })
          this.fileList = [];
          return false
        }
        return true
      },
      checkZpjz(file,fileList) {
        // 上传之前判断
        // debugger
        const isPDF = file.type === 'application/pdf'
        const isLt10M = file.size / 1024 / 1024 < 10
        if (!isPDF) {
          this.$message({
            type: 'error',
            message: '上传招聘简章文件只能是 PDF 格式！',
          })
          this.fileList = [];
          return false
        }
        if (!isLt10M) {
          this.$message({
            type: 'error',
            message: '招聘简章文件大小不能超过 10MB!',
          })
          this.fileList = [];
          return false
        }
        return true
      },
      
    
    },
  }
</script>

<style scoped>
  .step2-zy-container {
    height: 600px;
    border: 1px solid #409eff;
    border-radius: 8px;
    margin-bottom: 20px;
    padding-top: 40px;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/project/add-section/stepSection3.vue